import { LanguageISO } from "providers/types"

import { BaseHttpProvider } from "./base-http.provider"

export class HuaweiTipsProvider extends BaseHttpProvider {
  async find(locale: LanguageISO) {
    const response = await this.execute({
      uri: `/huawei-tips?_locale=${locale}`,
      method: "GET",
    })

    return response
  }
}
